import React, { Component } from 'react';
import PropTypes from 'prop-types';
import pick from 'lodash/pick';
import Input, { CENTER, LEFT } from '../Input/InputView';

import { isNumeric } from '../../../js/app/react/validators';
import { extractFirstLongestNumberFromString } from '../../../js/app/react/stringNumericUtils';

const WHITESPACE = 3;

const { ADV } = window;

export default class InputDollar extends Component {
  constructor() {
    super();
    this.onFocus = this.onFocus.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.onMeasureWidthRef = this.onMeasureWidthRef.bind(this);
    this.onInputRef = this.onInputRef.bind(this);
    this.onInputDollarRef = this.onInputDollarRef.bind(this);
    this.onPostRender = this.onPostRender.bind(this);
    this.state = {
      focused: false,
      textWidth: null,
      inputPaddingRight: null,
      inputDollarPaddingRight: null,
      inputDollarPaddingLeft: null,
      inputWidth: null,
    };
  }

  componentDidMount() {
    this.onPostRender();
  }

  componentDidUpdate() {
    this.onPostRender();
  }

  onInputRef(inputDOMElement) {
    this.inputDOMElement = inputDOMElement;
  }

  onInputDollarRef(inputDollarDOMElement) {
    this.inputDollarDOMElement = inputDollarDOMElement;
  }

  onPostRender() {
    if (this.measureWidthDOMElement) {
      const newTextWidth = parseFloat(ADV.util.getCss(this.measureWidthDOMElement, 'width'));
      if (isNumeric(newTextWidth)) {
        if (this.state.textWidth !== newTextWidth) {
          this.setState({
            textWidth: newTextWidth,
          });
        }
      }
    }

    if (this.inputDOMElement) {
      let newPaddingRight = parseFloat(ADV.util.getCss(this.inputDOMElement, 'paddingRight'));
      if (ADV.util.getCss(this.inputDOMElement, 'boxSizing') === 'border-box') {
        newPaddingRight -= parseFloat(ADV.util.getCss(this.inputDOMElement, 'paddingLeft'));
        newPaddingRight /= 2;
      }
      if (isNumeric(newPaddingRight)) {
        if (this.state.inputPaddingRight !== newPaddingRight) {
          this.setState({
            inputPaddingRight: newPaddingRight,
          });
        }
      }

      const newInputWidth = parseFloat(ADV.util.getCss(this.inputDOMElement, 'width'));
      if (isNumeric(newInputWidth)) {
        if (this.state.inputWidth !== newInputWidth) {
          this.setState({
            inputWidth: newInputWidth,
          });
        }
      }
    }

    if (this.inputDollarDOMElement) {
      const newPaddingRight = parseFloat(
        ADV.util.getCss(this.inputDollarDOMElement, 'paddingRight'),
      );
      if (isNumeric(newPaddingRight)) {
        if (this.state.inputDollarPaddingRight !== newPaddingRight) {
          this.setState({
            inputDollarPaddingRight: newPaddingRight,
          });
        }
      }

      const newPaddingLeft = parseFloat(ADV.util.getCss(this.inputDollarDOMElement, 'paddingLeft'));
      if (isNumeric(newPaddingLeft)) {
        if (this.state.inputDollarPaddingLeft !== newPaddingLeft) {
          this.setState({
            inputDollarPaddingLeft: newPaddingLeft,
          });
        }
      }
    }
  }

  onMeasureWidthRef(measureWidthDOMElement) {
    this.measureWidthDOMElement = measureWidthDOMElement;
  }

  onFocus() {
    this.setState({
      focused: true,
    });
  }

  onBlur(event) {
    this.setState({
      focused: false,
    });
    if (this.props.onBlur) {
      this.props.onBlur(event);
    }
  }

  onChange(eventArg) {
    const event = pick(eventArg, ['target']);
    let amount = event.target.value;
    if (amount) {
      amount = amount.replace(/[,]/g, '');
    }
    if (isNumeric(amount) || (amount || '').length === 0) {
      event.target.value = amount;
      this.props.onChange(event);
    } else {
      event.target.value = extractFirstLongestNumberFromString(amount);
      this.props.onChange(event);
    }
    eventArg.preventDefault();
    eventArg.stopPropagation();
  }

  render() {
    let amount = this.props.value;
    const { isLeftAligned, placeholder, placeholderClassName, isUnder, disabled, id } = this.props;

    if (isNumeric(amount)) {
      amount = ADV.util.number_format(amount, 0).toString();
    }

    const {
      textWidth,
      inputPaddingRight,
      inputDollarPaddingRight,
      inputWidth,
      inputDollarPaddingLeft,
    } = this.state;

    const showDollarGlyph =
      isNumeric(textWidth) &&
      isNumeric(inputPaddingRight) &&
      isNumeric(inputDollarPaddingRight) &&
      isNumeric(inputWidth) &&
      (isNumeric(this.props.value) ||
        (this.state.focused && (this.props.value || '').length === 0));

    return (
      <div className={`input-dollar ${this.props.className}`} ref={this.onInputDollarRef}>
        {showDollarGlyph && (
          <i
            style={{
              right: !isLeftAligned
                ? inputWidth / 2 +
                  Math.min(textWidth, inputWidth) / 2 +
                  inputPaddingRight +
                  inputDollarPaddingRight +
                  WHITESPACE
                : 'auto',
              left: isLeftAligned ? inputDollarPaddingLeft : 'auto',
              color: disabled ? '#6C727F' : '#444',
            }}
            id={`${id}-icon`}
          >
            $
          </i>
        )}
        <div className="measure-width" ref={this.onMeasureWidthRef}>
          {amount}
        </div>
        <Input
          disabled={disabled}
          isUnder={isUnder}
          alignment={isLeftAligned ? LEFT : CENTER}
          placeholderClassName={placeholderClassName}
          placeholder={placeholder}
          ref={this.onInputRef}
          value={amount}
          type="tel"
          maxLength={this.props.maxLength}
          onChange={this.onChange}
          onBlur={this.onBlur}
          onFocus={this.onFocus}
          id={id}
        />
      </div>
    );
  }
}

InputDollar.defaultProps = {
  className: '',
  value: '',
  onBlur: null,
  isLeftAligned: false,
  placeholderClassName: '',
  isUnder: undefined,
  disabled: false,
  id: undefined,
};

InputDollar.propTypes = {
  disabled: PropTypes.bool,
  maxLength: PropTypes.number.isRequired,
  className: PropTypes.string,
  value: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string.isRequired,
  onBlur: PropTypes.func,
  isLeftAligned: PropTypes.bool,
  placeholderClassName: PropTypes.string,
  isUnder: PropTypes.bool,
  id: PropTypes.string,
};
